import styled from 'styled-components';

export const Wrapper = styled.div`
	display: flex;
	margin: 30px;
	flex-direction: column;
	align-items: center;
	gap: 20px;
`;
